/**
 * A simple stack implementation for keeping a fixed history size.
 * This class is iterable and has a length, but no array methods like forEach/map, ...
 */
class SearchHistory {
    constructor(maxHistoryLength = 5) {
        this.history = []
        this.maxHistoryLength = maxHistoryLength
        this.index = -1
    }

    /**
     * This makes our valueHistory object iterable using for x of y
     * @returns {IterableIterator<*>}
     */
    [Symbol.iterator]() {
        return this.history.values()
    }

    /**
     * Make it easier for the consumer to check the current length
     * @returns {number}
     */
    get length() {
        return this.history.length
    }

    /**
     * Push something into history
     * @param state
     * @returns {number}
     */
    push(state) {
        this.history.push(state)
        this.history = this.history.slice(
            Math.max(0, this.history.length - this.maxHistoryLength)
        )
        this.index = Math.min(this.index + 1, this.maxHistoryLength - 1)
        return this.history.length
    }

    /**
     * Empties the history.
     * @returns {[]}
     */
    clear() {
        if (this.history.length > 0) {
            this.history = []
            return this.history
        }
        throw new SearchHistoryError('No history to clear')
    }
}

export class SearchHistoryError extends Error {}
export default SearchHistory
